import { useQuery } from "@tanstack/react-query";
import { api, BACKEND_URL } from "@/lib/api";

export const DEFAULT_SITE = {
  name: "BachatRaja", tagline: "Verified deals, honest savings", logo_url: "", favicon_url: "", og_image_url: "",
  primary_color: "#059669", accent_color: "#fbbf24", ga_id: "", gsc_verification: "",
  seo_title: "BachatRaja - Verified Deals & Coupons in India",
  seo_description: "BachatRaja - verified Indian shopping deals, coupons and honest buying guides. Prices in INR.",
};

export const useSite = () => {
  const { data } = useQuery({ queryKey: ["public-site"], queryFn: () => api.get("/public/site").then((r) => r.data), staleTime: 300_000 });
  return { ...DEFAULT_SITE, ...(data || {}) };
};

// Uploaded files are served by the backend under /api/files/...; pasted links are used as-is.
export const assetUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u || "");

const hexRgb = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));
const mix = (rgb, to, t) => rgb.map((c) => Math.round(c + (to - c) * t));

// Shade ladder around the chosen colour: positive = towards white, negative = towards black.
const MAIN_STEPS = { 50: 0.92, 100: 0.82, 200: 0.64, 300: 0.44, 400: 0.24, 500: 0.1, 600: 0, 700: -0.18, 800: -0.34, 900: -0.48, 950: -0.66 };
const ACCENT_STEPS = { 50: 0.86, 100: 0.72, 200: 0.5, 300: 0.25, 400: 0, 500: -0.12, 600: -0.25, 700: -0.4, 800: -0.52, 900: -0.62, 950: -0.75 };

export const shades = (hex, accent = false) => {
  const rgb = hexRgb(hex);
  return Object.fromEntries(Object.entries(accent ? ACCENT_STEPS : MAIN_STEPS).map(([k, t]) => [k, (t >= 0 ? mix(rgb, 255, t) : mix(rgb, 0, -t)).join(" ")]));
};

const lum = (hex) => {
  const [r, g, b] = hexRgb(hex).map((c) => { c /= 255; return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4; });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
export const contrastWithWhite = (hex) => 1.05 / (lum(hex) + 0.05);
